import { BrandInfo } from '@lib/domain/settings';
import { Settings } from '@lib/domain/settings/interface';
import { HTTPService } from '@lib/infra/HTTPService/HTTPService';

interface Dependencies {
    httpService: HTTPService;
}

export class SettingsRepository implements Settings {
    private httpService: HTTPService;

    constructor({ httpService }: Dependencies) {
        this.httpService = httpService;
    }

    async getBrand(): Promise<BrandInfo> {
        const { data } = await this.httpService.get({
            url: 'brand/spotify',
        });
        return data;
    }
}
